import { Route, Switch } from 'react-router-dom'
import { ErrorInfo } from 'App/components/ErrorInfo/ErrorInfo'
import { routes } from './routes'
import { Wrapper } from 'App/components/Wrapper/Wrapper'
import React from 'react'

const NotFoundRoute = ({ ...rest }) => (
	<Route {...rest} render={() => <ErrorInfo />} />
)

export const Routes = (): JSX.Element => {
	return (
		<Switch>
			{routes.map(({ name, path, wrapper, element: Element }) => (
				<Route
					key={name}
					exact
					path={path}
					component={(props: any) =>
						wrapper ? (
							<Wrapper>
								<Element {...props} />
							</Wrapper>
						) : (
							<Element {...props} />
						)
					}
				/>
			))}
			<NotFoundRoute />
		</Switch>
	)
}
